// extracted by mini-css-extract-plugin
export default {"root":"style_root__cWWEs","widget":"style_widget__JduRy","main":"style_main__ay6qF"};